import { useSearchParameters } from "@/components/signup/hooks";

import { isProductKey, ProductKeyType } from "../models";

export function useProductKeys(): readonly ProductKeyType[] {
    const { products } = useSearchParameters();
    return products.filter(isProductKey);
}
